import { render, staticRenderFns } from "./import-transmittals.vue?vue&type=template&id=5a858a57"
import script from "./import-transmittals.vue?vue&type=script&lang=js"
export * from "./import-transmittals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports